import React, { useEffect } from 'react';
import './MindwarSupport.css';

function MindwarSupport() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="support-wrapper">
      <div className="support-container">
        <div className="support-header">
          <h1>MINDWAR DESTEK MERKEZİ</h1>
          <p>Size nasıl yardımcı olabiliriz?</p>
        </div>

        <div className="support-content">
          <div className="faq-section">
            <h2>Sıkça Sorulan Sorular</h2>
            
            <div className="faq-item">
              <div className="faq-question">Hesabımı nasıl silebilirim?</div>
              <div className="faq-answer">
                Hesabınızı silmek için uygulama içindeki Ayarlar &gt; Hesap &gt; Hesabımı Sil adımlarını takip edebilir veya aşağıdaki iletişim kanallarından bize silme talebinizi iletebilirsiniz. Talebiniz alındıktan sonra verileriniz 30 gün içinde kalıcı olarak silinecektir.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">Şifremi unuttum, ne yapmalıyım?</div>
              <div className="faq-answer">
                Giriş ekranındaki "Şifremi Unuttum" bağlantısına tıklayarak kayıtlı e-posta adresinize şifre sıfırlama bağlantısı gönderebilirsiniz.
              </div>
            </div>

            <div className="faq-item">
              <div className="faq-question">Uygulama çöküyor veya hata veriyor.</div>
              <div className="faq-answer">
                Lütfen uygulamanın en son sürümünü kullandığınızdan emin olun. Sorun devam ederse, cihazınızın modelini ve hatanın ekran görüntüsünü bize e-posta ile gönderin.
              </div>
            </div>
            
             <div className="faq-item">
              <div className="faq-question">Puanlarım görünmüyor.</div>
              <div className="faq-answer">
                İnternet bağlantınızı kontrol edip uygulamayı yeniden başlatmayı deneyin. Sunucu senkronizasyonu bazen birkaç dakika sürebilir.
              </div>
            </div>
          </div>

          <div className="contact-box">
            <h3>Bizimle İletişime Geçin</h3>
            <p style={{ marginBottom: '20px' }}>
              Sorularınız, önerileriniz veya teknik destek talepleriniz için bize ulaşın.
            </p>
            
            <div className="contact-info-item">
              <span className="contact-label">E-posta:</span>
              <span className="contact-value">selmanatabek@hotmail.com</span>
            </div>
            
            <div className="contact-info-item">
              <span className="contact-label">Telefon:</span>
              <span className="contact-value">+90 555 334 23 32</span>
            </div>
            
            <div className="contact-info-item">
              <span className="contact-label">Adres:</span>
              <span className="contact-value">İstanbul, Türkiye</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MindwarSupport;
